import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import * as data from '../../../data/prices.json';

@Component({
  selector: 'app-home-price',
  templateUrl: './home-price.component.html',
  styleUrls: ['./home-price.component.scss']
})

export class HomePriceComponent implements OnInit {

  prices: any = (data as any).default;
  colorCodes: any[] = ['#2548DB', '#FF9900', '#00ABAB', '#A1887F', '#607D8B', '#039BE5', '#009688'];

  constructor(private router: Router, private apiService: ApiService) { }

  ngOnInit() {
    this.getPrices();
  }

  private getPrices() {
    // this.apiService.getPrices().subscribe((prices) => {
    //   this.prices = prices.plans;
    // });
  }


  onMoreClick(cardDetails) {
    this.router.navigateByUrl('home/pricing');
  }

}
